import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Observable } from 'rxjs';
import { SpecialistTableComponent } from 'src/app/components/tables/specialist/specialist-table.component';
import { Clinic } from 'src/app/models/clinic.model';
import { Specialist } from 'src/app/models/specialist.model';
import { ClinicService } from 'src/app/services/clinic.service';
import { SideBarMenuService } from 'src/app/services/sidebar-menu.service';

@Component({
  selector: 'clinic-specialists',
  standalone: true,
  imports: [BreadcrumbModule, AsyncPipe, SpecialistTableComponent],
  templateUrl: './specialists.component.html',
})
export class ClinicSpecialistsComponent implements OnInit {
  appName: string = localStorage.getItem('appName');
  appId: string = localStorage.getItem('appId');
  clinic: Clinic;

  specialists$: Observable<Specialist[]>;
  home: MenuItem;
  breadcrumbItems: MenuItem[] = [];

  private clinicService = inject(ClinicService);
  private sidebarMenuService = inject(SideBarMenuService);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.clinic = this.route.snapshot.data['clinic'];
    this.home = {
      icon: 'pi pi-fw pi-mobile',
      routerLink: '/',
      command: () => this.sidebarMenuService.clearSessionStorage(),
    };
    this.breadcrumbItems = [
      { label: this.appName },
      { label: 'Clínicas', routerLink: '/clinics' },
      { label: this.clinic.name },
      { label: 'Especialistas', styleClass: 'font-bold' },
    ];
    this.specialists$ = this.clinicService.findSpecialists(this.clinic.id);
  }
}
